import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from "@angular/common/http";

@Injectable()
export class DriversService {

  httpOptions ={
    headers: new HttpHeaders({'Content-Type':'application/json'})
  };

  constructor(private _http: HttpClient) { }

  getDrivers() {
    return this._http.get('/users');
  }

  listDrivers(){
      return this._http.get('/drivers');
  }

  createDriver(data) {
      let body = JSON.stringify(data);
      return this._http.post('/drivers/', body, this.httpOptions);
  }

  updateDriver(data) {
      let body = JSON.stringify(data);
      return this._http.put('/drivers/' + data.id, body, this.httpOptions);
  }

  deleteDriver(data) {
      return this._http.delete('/drivers/' + data.id);
  }

  deleteAttachment(data, type){
      return this._http.get('/drivers/' + data.id + '/delete/' + type);
  }

  getDriverByUserId(userId) {
    let filter = JSON.stringify({ "where": { "userId": userId } })
    return this._http.get('/drivers?filter='+filter);
  }

  getDriverByDriverId(id) {
    return this._http.get('/drivers/'+id);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/drivers/drivers.service.ts